const DIMENSION_EXCLUSIONS = ['mattresses', 'wooden-beds', 'dresser-set', 'bedroom-set', 'sofas'];

export function enrichProductDefaults(product) {
  const isDimensionExempt = DIMENSION_EXCLUSIONS.includes(product.category);
  const hasExplicitOutOfStock = product.inStock === false;
  const explicitCount = Number(product.stockCount ?? product.stock);
  const stockCount = Number.isFinite(explicitCount) ? explicitCount : (hasExplicitOutOfStock ? 0 : 15);
  return {
    ...product,
    availableProvinces: Array.isArray(product.availableProvinces) && product.availableProvinces.length ? product.availableProvinces : ['ontario'],
    availableCities: Array.isArray(product.availableCities) ? product.availableCities : [],
    provincePrices: { ontario: product.priceCAD, ...(product.provincePrices || {}) },
    dimensions: product.dimensions || (isDimensionExempt ? null : { height: 30, width: 50, depth: 16, unit: 'in' }),
    stockCount,
    inStock: hasExplicitOutOfStock ? false : stockCount > 0,
  };
}
